import db from "@/plugins/dexie";
import { USER_STORAGE } from '@/constants/STORAGE';
import apirecebimentoweb from '@/services/api-recebimentoweb';
import geraData from "../geradata";
import moment from "moment-timezone";
import store from "@/store";


function isLockExpirado(item, minutos = 1) {
  if (!item.appdataprocesso) return false;
  const dataAtual = moment(geraData());
  const dataProcesso = moment(item.appdataprocesso);
  
  console.log('[APONTAMENTO] Data no LOCK: ', dataAtual.diff(dataProcesso, 'minutes'));
  return dataAtual.diff(dataProcesso, 'minutes') > minutos;
}

export default async function $_enviaApontamento() {
  const tokenRaw = sessionStorage.getItem('auth:token');
  if (!tokenRaw) return;

  const token = JSON.parse(tokenRaw);
  const idusuario = sessionStorage.getItem(USER_STORAGE.useidusuario);
  let apontamentosArray = await db.apontamentoproducao.toArray();
 
  // 1️⃣ Buscar apontamentos para envio (sem confiar cegamente)
  const apontamentos = await apontamentosArray.filter(a =>
    a.appdatanuvem === null && !a.appfalhapermanente
  );

  // 2️⃣ Processar UM POR UM (isso é crucial)
  for (const apontamento of apontamentos) {
    let item;

    // 3️⃣ Lock atômico por item
    const podeProcessar = await db.transaction(
      'rw',
      db.apontamentoproducao,
      async () => {
        const atual = await db.apontamentoproducao.get(apontamento.id);
        if (!atual) return false;

        // Já sincronizado
        if (atual.appdatanuvem) return false;

        // Em processo e NÃO expirado → pula
        if (atual.appemprocesso && !isLockExpirado(atual)) {
          return false;
        }

        // Locka
        await db.apontamentoproducao.update(atual.id, {
          appemprocesso: true,
          appdataprocesso: geraData()
        });

        item = { ...atual };
        return true;
      }
    );

    if (!podeProcessar || !item) continue;

    // 4️⃣ Montar payload
    const payload = {
      appidordemproducao: item.appidordemproducao,
      appidaberturaloteembalagem: item.appidaberturaloteembalagem,
      appquantidadeembalagem: item.appquantidadeembalagem,
      appidlocalarmazenamento: item.appidlocalarmazenamento,
      appidaberturalote: item.appidaberturalote,
      apppeso: item.apppeso,
      appdatapesagem: item.appdatapesagem,
      appnumerobag: item.appnumerobag,
      appnumerobalanca: item.appnumerobalanca,
      appidturno: item.appidturno,
      appquantidade: item.appquantidade,
      appidusuario: idusuario,
      appdataalteracao: geraData(),
      appposicaoarmazem: item?.appposicaoarmazem,
      appidfabrica: item.appidfabrica,
      appidlocalmovimentacaoestoque: item.appidlocalmovimentacaoestoque,
    };

    if (item?.appidnuvem && item.appidnuvem !== 'null') payload.id = item.appidnuvem;

    // 5️⃣ Enviar
    let res;
    try {
      if (item?.appidnuvem && item.appidnuvem !== 'null') {
        console.log('put', payload);
        res = await apirecebimentoweb.put(
          `/apontamentoproducao/${item.appidnuvem}`,
          payload,
          { headers: { Authorization: `Bearer ${token.token}` } }
        );
      } else {
        console.log('post', payload);
        res = await apirecebimentoweb.post(
          '/apontamentoproducao',
          payload,
          { headers: { Authorization: `Bearer ${token.token}` } }
        );
      }
    } catch (err) {
      console.error('[ENVIO_APONTAMENTO_ERRO]', item.id, err);

      if (err?.response?.status === 422) {
        // Rejeição definitiva do servidor (ex.: lote+bag duplicado) → retentar não resolve.
        await db.apontamentoproducao.update(item.id, {
          appemprocesso: false,
          appdataprocesso: null,
          appfalhapermanente: true,
        });
        continue;
      }

      // Erros transitórios (rede, servidor fora) mantêm o lock → serão reavaliados pelo TTL
      continue;
    }

    if (!res?.data) continue;

    // 6️⃣ Persistir sucesso
    const alteracao = moment.utc(res.data.appdataalteracao).format('YYYY-MM-DD HH:mm:ss.SSS');

    await db.apontamentoproducao.update(item.id, {
      appidusuario: res.data.appidusuario,
      appidnuvem: res.data.id ?? item.appidnuvem,
      appdataalteracao: alteracao,
      appdatanuvem: alteracao,
      appemprocesso: false,
      appdataprocesso: null
    });

    store.dispatch('cache/atualizaData', {
      data: alteracao,
      tabela: 'apontamentoproducao'
    });
  }
}
